import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField, Stack } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import { DateTime } from 'luxon';
import Loader from '../../Components/Loader'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';


const AbhaRegisterList = () => {
    const [date, setDate] = useState(DateTime.now().toFormat('yyyy-MM-dd'));
    const [patientList, setPatientList] = useState([]);
    const [pageSize, setPageSize] = useState(10);
    const [page, setPage] = useState(0);
    const [loader, setLoader] = useState(false);


    useEffect(() => {
        getpatientList(date);
    }, [date]);

    const getpatientList = (date="") => {
    try{
        setLoader(true);
        var Searchdate = date ? DateTime.fromJSDate(new Date(date)).toFormat('yyyy-MM-dd') : DateTime.now().toFormat('yyyy-MM-dd');
        var API_URL = Serviceurls.ABHA_REGISTER_LIST + `?date=${Searchdate}`;
        RestAPIService.getAll(API_URL).
        then((response) => {
        if (response?.data?.status === "success") {
            setPatientList(response?.data?.data || []);
            setLoader(false);
        } else {
            setLoader(false);
            // errorMessage(response.data.message)
        }
        }).catch((error) => {
            setLoader(false);
        // errorMessage(error.message)
        })

    }catch(e){
        console.error("Error fetching patient list:", e);
    }
    }

    const renderTable = () => {
        try {
            patientList.forEach((ele, index) => ele.sno = index + 1);
            
            const columns = [
                {
                    field: 'PatientDetails',
                    headerName: 'Patient Details',
                    headerClassName: 'eMed_Apt_TblHead',
                    flex: 0.25,
                    renderCell: ({ row }) => (
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            <div>
                                {[row?.first_name, row?.middle_name, row?.last_name].filter(Boolean).join(" ")}
                            </div>
                            {row?.uhid && (
                                <div style={{ fontSize: '0.85em', color: '#1976d2' }}>
                                    {row.uhid}
                                </div>
                            )}
                        </div>
                    ),
                    density: 'compact'
                },
                {
                    field: 'patient_abha_health_id',
                    density: 'compact',
                    headerName: 'ABHA Number',
                    headerClassName: 'eMed_Apt_TblHead',
                    flex: 0.13,
                    renderCell: ({ row }) => (
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {row?.patient_abha_health_id || '-'}
                        </div>
                    )
                },
                {
                    field: 'patient_abha_health_address',
                    density: 'compact',
                    headerName: 'ABHA Address',
                    headerClassName: 'eMed_Apt_TblHead',
                    flex: 0.25,
                    renderCell: ({ row }) => (
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {row?.patient_abha_health_address || '-'}
                        </div>
                    )
                },
                {
                    field: 'dob',
                    density: 'compact',
                    headerName: 'D.O.B / Gender',
                    headerClassName: 'eMed_Apt_TblHead',
                    flex: 0.13,
                    renderCell: ({ row }) => (
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            <div>{row?.dob || '-'}</div>
                            {row?.gender && (
                                <div style={{ fontSize: '0.85em', color: '#555' }}>
                                    {String(row.gender).toLowerCase().startsWith("m")
                                        ? "Male"
                                        : String(row.gender).toLowerCase().startsWith("f")
                                            ? "Female"
                                            : "Other"};
                                </div>
                            )}
                        </div>
                    )
                },
                {
                    field: 'address',
                    density: 'compact',
                    headerName: 'Contact Details',
                    headerClassName: 'eMed_Apt_TblHead',
                    flex: 0.25,
                    renderCell: ({ row }) => (
                        <div style={{ whiteSpace: 'normal', wordBreak: 'break-word' }}>
                            {[row?.address, row?.district, row?.state, row?.pincode, row?.mobile].filter(Boolean).join(", ")}
                            {/* {(row?.address + row?.district + row?.state + row?.pincode + (row?.mobile ? "Mob:" + row?.mobile))} */}
                        </div>
                    )
                }
            ]
            return (
            <div>
            <Box className='eMed_IPAptTbl_Con'>
                <DataGrid
                rows={patientList}
                columns={columns}
                getRowId={(row) => row.sno}
                pageSize={pageSize}
                page={page}
                rowsPerPageOptions={[10, 20, 30]}
                sx={{
                    "& .MuiDataGrid-cell": {
                        fontSize: "0.85vw"
                    }
                }}
                // components={{
                //     Toolbar: this.gridToolBar,
                //     NoRowsOverlay: () => (
                //     <Stack className='eMed_conf_nodata'>
                //         {t("NoRecordsFound")}
                //     </Stack>
                //     )
                // }}
                // localeText={{
                //     toolbarColumns: "",
                //     toolbarDensity: "",
                //     toolbarExport: "",
                //     toolbarFilters: "",
                //     toolbarExportPrint: ""
                // }}
                density={'compact'}
                rowHeight={150}
                pagination
                onPageChange={(newPage) => { setPage(newPage) }}
                onPageSizeChange={(newPageSize) => { setPageSize(newPageSize) }}
                disableSelectionOnClick
                // onCellClick={(params) => this.routeToDemograhics(params)}
                />
            </Box>
            </div>
        )
        }catch (error) {
            console.error("Error rendering table:", error);
        }
    }

    return (
        <Box sx={{ p: 3 }}>
            <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
                <Typography sx={{fontSize: "1vw", fontWeight: 600}}>ABHA Registered / Updated Patient List</Typography>
                {/* <TextField
                    type="date"
                    size="small"
                    value={date}
                    onChange={(e) => setDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                /> */}
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                    <DatePicker
                        value={date ? date : null}
                        name={"datePicker"}
                        inputFormat={'DD-MM-YYYY'}
                        views={["year", "month", "day"]}
                        onChange={(newDate) => {
                            setDate(newDate);
                        }}
                        maxDate={new Date()}
                        renderInput={(params) => <TextField
                            {...params}
                            label={"Date"}
                            name={"Date"}
                            variant="outlined"
                            onKeyDown={(e) => e.preventDefault()}
                            sx={{ width: '14dvw', marginRight: '0.3vw' }}
                            size='small'
                        />}
                    />
                </LocalizationProvider>
            </Box>
            {renderTable()}
            <Loader loaderOpen={loader} />
        </Box>
    );
};

export default AbhaRegisterList;